import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/menu/Navbar';
import LoginForm from './components/login/Home';
import ProfessionalSolution from './components/servicios/ProfessionalSolution';
import TechnicalAssistance from './components/servicios/TechnicalAssistance';
import Register from './components/register/Register';
import Footer from './components/menu/Footer';
import RecordarPassword from './components/login/RecordarPassword';
import { SERVICE_TYPES } from './helper/types';
import { getSession, logout } from './hooks/security/auth';
import './assets/styles/App.css';

function App() {
  const [isLogin, setIsLogin] = useState(false);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const init = async () => {
      try {
        const session = await getSession();

        if (session?.authenticated) {
          setIsLogin(true);
        }
      } catch {
        await getSession();
      } finally {
        setLoading(false);
      }
    };

    init();
  }, []);

  /**
   * 2Logout real (backend + frontend)
   */
  const handleLogout = async () => {
    try {
      await logout();
    } finally {
      setIsLogin(false);
      setData(null);
    }
  };

  /**
   * Login success (la cookie ya está puesta por backend)
   */
  const handleLoginSuccess = (userData) => {
    setIsLogin(true);
  };

  if (loading) {
    return <div>Cargando...</div>;
  }

  return (
    <Router>
      <div className="app-container">
        <Navbar isLogin={isLogin} onLogout={handleLogout} data={data} />

        <div className="internal-container">
          <Routes>
            <Route
              path="/"
              element={
                <LoginForm
                  isLogin={isLogin}
                  onLoginSuccess={handleLoginSuccess}
                  data={data}
                  setData={setData}
                />
              }
            />

            <Route
              path="/services/solution"
              element={<ProfessionalSolution type={SERVICE_TYPES.NONE} />}
            />

            <Route
              path="/services/asistance"
              element={<TechnicalAssistance type={SERVICE_TYPES.NONE} />}
            />

            <Route path="/forgot-password" element={<RecordarPassword />} />
            <Route path="/register" element={<Register />} />
          </Routes>
        </div>

        <Footer />
      </div>
    </Router>
  );
}

export default App;